import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LoadingDots } from 'site-modules/shared/components/loading-dots/loading-dots';

import './co-driver-mcp-loader.scss';

export const CoDriverMcpLoader = ({ className = undefined }) => (
  <div
    className={classNames('co-driver-mcp-loader', className)}
    aria-live="polite"
    aria-busy="true"
    aria-label="Loading app"
  >
    <LoadingDots />
  </div>
);

CoDriverMcpLoader.propTypes = {
  className: PropTypes.string,
};
